export default __webpack_public_path__ + "navigation-examples-waypoint-arrival-screen-960-460050fd61a70ba35b46e564655b1602.webp";